import { useQueryClient } from '@tanstack/react-query';
import { useSse } from '@/lib/sse';
import { useAuthStore } from '@/stores/authStore';

const TOPIC_TO_KEYS: Record<string, string[][]> = {
  jobs: [['jobs'], ['batches'], ['dashboard']],
  vms: [['vms'], ['dashboard']],
  states: [['outbound_pushes'], ['contacts'], ['dashboard']],
  forms: [['form_fills']],
  inbound: [['form_fills'], ['contacts']],
};

export function useLiveSync() {
  const qc = useQueryClient();
  const enabled = !!useAuthStore((s) => s.token);

  useSse(
    ['jobs', 'vms', 'states', 'forms', 'inbound'],
    (e) => {
      const keys = TOPIC_TO_KEYS[e.topic];
      if (!keys) return;
      for (const k of keys) qc.invalidateQueries({ queryKey: k });
    },
    enabled,
  );
}
